export enum Position {
    Left = 1,
    Center = 2,
    Right = 3,
    None = 4,
}